import React from 'react';
import { CUP_WINNERS_2026 } from '../data/cupWinners2026';
import './CupWinners.css';

const CupWinners: React.FC = () => {
  return (
    <div className="cup-winners-page">
      <nav className="cup-winners-nav" aria-label="Junior Cup">
        <a className="cup-winners-nav__brand" href="/">
          <img
            className="cup-winners-nav__logo"
            src="/newlogo.png"
            alt="FK Junior"
            decoding="async"
          />
        </a>
        <a className="cup-winners-nav__home" href="/">
          FK Junior
        </a>
      </nav>

      <main className="cup-winners-main">
        <header className="cup-winners-hero">
          <div className="cup-winners-hero__trophy" aria-hidden>
            🏆
          </div>
          <h1>Pobednici — Junior Cup 2026</h1>
          <p>Novi Sad, maj 2026</p>
        </header>

        <div className="cup-winners-list">
          {CUP_WINNERS_2026.map((gen) => (
            <section key={gen.year} className="cup-winners-gen" aria-labelledby={`cup-winners-${gen.year}`}>
              <header className="cup-winners-gen__head">
                <span className="cup-winners-gen__icon" aria-hidden>
                  🏆
                </span>
                <h2 id={`cup-winners-${gen.year}`} className="cup-winners-gen__year">
                  Generacija {gen.year}
                </h2>
              </header>
              <ul className="cup-winners-medals">
                <li>
                  <span className="cup-winners-medals__place" aria-hidden>
                    🥇
                  </span>
                  <span className="cup-winners-medals__team">{gen.gold}</span>
                </li>
                <li>
                  <span className="cup-winners-medals__place" aria-hidden>
                    🥈
                  </span>
                  <span className="cup-winners-medals__team">{gen.silver}</span>
                </li>
                <li>
                  <span className="cup-winners-medals__place" aria-hidden>
                    🥉
                  </span>
                  <span className="cup-winners-medals__team">{gen.bronze}</span>
                </li>
              </ul>
            </section>
          ))}
        </div>

        <footer className="cup-winners-footer">
          <p>
            <a href="/">juniorfk.com</a>
          </p>
        </footer>
      </main>
    </div>
  );
};

export default CupWinners;
